import { createSvgIcon } from '@automata/mui-theme';
export const TuberackIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 35V23H26V35H22ZM28 35V23H31V35H28ZM33 35H36V23H33V35ZM38 35V23H42V35H38ZM23 38H21C19.8954 38 19 37.1046 19 36V22C19 20.8954 19.8954 20 21 20H43C44.1046 20 45 20.8954 45 22V36C45 37.1046 44.1046 38 43 38H41V46H38V38H26V46H23V38ZM23 58V69C23 73.9706 27.0294 78 32 78C36.9706 78 41 73.9706 41 69V58H38V69C38 72.3137 35.3137 75 32 75C28.6863 75 26 72.3137 26 69V58H23ZM55 58V69C55 73.9706 59.0294 78 64 78C68.9706 78 73 73.9706 73 69V58H70V69C70 72.3137 67.3137 75 64 75C60.6863 75 58 72.3137 58 69V58H55ZM70 46V38H58V46H55V38H53C51.8954 38 51 37.1046 51 36V22C51 20.8954 51.8954 20 53 20H75C76.1046 20 77 20.8954 77 22V36C77 37.1046 76.1046 38 75 38H73V46H70ZM54 35V23H58V35H54ZM60 35V23H63V35H60ZM65 35H68V23H65V35ZM70 35V23H74V35H70Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M81 49H15V55H81V49ZM12 46V58H84V46H12Z"
    />
  </svg>,
  'TuberackIcon'
);
